import actionTypes from '../actionTypes';

export const FETCH_TRADES = actionTypes('FETCH_TRADES');
export const FETCH_TRADE_DETAILS = actionTypes('FETCH_TRADE_DETAILS');
export const FETCH_TRADES_SUMMARY = actionTypes('FETCH_TRADES_SUMMARY');
export const SET_TRADE_STATUS = actionTypes('SET_TRADE_STATUS');
